module.exports = __webpack_public_path__ + "static/media/genevec.ae3959d3.png";